let baseUrl = $('meta[name="base-url"]').attr('content');
let csrfToken = $('meta[name="csrf-token"]').attr('content');
let mobileAlertVisible = false; // Flag to avoid multiple alerts

// Ensure that CSRF token is included in every AJAX request
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

const formOptions = {
    noAlerts: true
};

// Set the local server path for Formio.js libraries
Formio.setBaseUrl(baseUrl); // Replace with your local server URL
Formio.setApiUrl(baseUrl); // Replace with your local server URL
Formio.setProjectUrl(baseUrl + '/form-submission');
Formio.icons = 'fontawesome';

let currentPageNumber = 0;

document.addEventListener('DOMContentLoaded', function () {

    Formio.createForm(
        document.getElementById('formio'),
        formDefinition, {
            ...formOptions,
            language: formData?.language || 'en',
            i18n: formDefinition.i18n
        }
    ).then(async function (form) {

        form.submission = {
            data: formData,
        };

        form.nosubmit = true;

        const urlParams = new URLSearchParams(window.location.search);
        const encodedStatus = urlParams.get('status');

        let paymentStatus = '';
        try {
            paymentStatus = atob(encodedStatus || '');
        } catch (e) {
            paymentStatus = '';
        }

        if (paymentStatus === 'payment_failed') {
            Swal.fire({
                icon: 'error',
                title: 'Payment Failed',
                text: 'Your payment was unsuccessful. Kindly retry again.',
                confirmButtonText: 'OK'
            });
        }

        let previousPageIndex = 0;
        let lastVisitedPage = 0;

        // Function to add move buttons to each row
        function addMoveButtons() {
            form.everyComponent(function (component) {
                if (component?.component?.type === 'datagrid' && component?.component?.attributes?.enableMoveUpMoveDown) {
                    const gridInstance = component;
                    const componentKey = component?.component?.key ?? '';
                    const dataGridElement = $(gridInstance.element);
                    const rows = dataGridElement.find('tbody').find('tr');

                    rows.each(function (index, row) {
                        const $row = $(row);
                        const $targetTd = $row.find('td:first');

                        row.preference = `P${index + 1}`;

                        const moveUpButtonExists = $targetTd.find('.formio-move-up-btn').length > 0;
                        const moveDownButtonExists = $targetTd.find('.formio-move-down-btn').length > 0;

                        if (!moveDownButtonExists && index < (rows.length - 1)) {
                            const moveDownButton = $(`<button data-key="datagrid-${componentKey}" type="button" class="btn btn-default formio-move-down-btn far fa-arrow-alt-circle-down" data-index="${index}" data-component-key="${componentKey}"></button>`);
                            $targetTd.append(moveDownButton);
                        }

                        if (!moveUpButtonExists && index > 0) {
                            const moveUpButton = $(`<button data-key="datagrid-${componentKey}" type="button" class="btn btn-default formio-move-up-btn far fa-arrow-alt-circle-up" data-index="${index}" data-component-key="${componentKey}"></button>`);
                            $targetTd.append(moveUpButton);
                        }

                    });
                }
            });
        }

        // Function to move rows
        function moveRow(componentKey, fromIndex, toIndex) {
            if (componentKey != '') {
                const gridInstance = form.getComponent(`${componentKey}`);
                const gridData = gridInstance.dataValue;
                const isMoveUp = fromIndex > toIndex;

                if (toIndex >= 0 && toIndex < gridData.length) {

                    const temp = gridData[fromIndex];
                    gridData[fromIndex] = gridData[toIndex];
                    gridData[toIndex] = temp;

                    if (isMoveUp) {
                        gridData[fromIndex].preference = `P${toIndex + 2}`;
                        gridData[toIndex].preference = `P${fromIndex}`;
                    } else {
                        gridData[toIndex].preference = `P${fromIndex + 2}`;
                        gridData[fromIndex].preference = `P${toIndex}`;
                    }

                    gridInstance.setValue(gridData);
                    gridInstance.redraw();

                    gridInstance.on('render', addMoveButtons);

                    addMoveButtons();
                }
            }
        }

        $(document).on('click', '.formio-move-up-btn', function () {
            const index = $(this).data('index');
            const componentKey = $(this).data('component-key');
            moveRow(componentKey, index, index - 1);
        });

        $(document).on('click', '.formio-move-down-btn', function () {
            const index = $(this).data('index');
            const componentKey = $(this).data('component-key');
            moveRow(componentKey, index, index + 1);
        });

        // Initial application of move buttons
        form.on('render', function () {
            addMoveButtons();

            setTimeout(() => {
                applyPaginationStyling();
            }, 200);
        });

        if (formDefinition && formDefinition.display && formDefinition.display === 'wizard') {
            if (form && form.pages && form.pages.length) {
                await form.ready;

                lastVisitedPage = parseInt(formData?.profileCompletedPage ?? 0);

                // Prevent overflow
                if (lastVisitedPage >= form.pages.length) {
                    lastVisitedPage = form.pages.length - 1;
                }

                // Prevent negative value
                if (lastVisitedPage < 0) {
                    lastVisitedPage = 0;
                }

                // Set the page only if valid
                if (typeof lastVisitedPage === 'number') {

                    // Delay required because Formio internally resets wizard page
                    setTimeout(() => {

                        form.setPage(lastVisitedPage).then(() => {
                            currentPageNumber = lastVisitedPage;

                            setTimeout(() => {
                                applyPaginationStyling();
                            }, 200);

                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });

                        });

                    }, 300);
                }
            }
        }

        form.on('wizardPageSelected', async function (event) {
            const currentPageIndex = form.page;
            let actionName = 'nextPage';
            if (currentPageIndex >= 0) {
                try {
                    if (currentPageIndex < (form.pages.length - 1)) {
                        await form.nextPage();
                    } else if (currentPageIndex === (form.pages.length - 1)) {
                        actionName = '';
                    }

                    await saveFormData(form, actionName, currentPageIndex);
                    currentPageNumber = form.page;

                    setTimeout(() => {
                        applyPaginationStyling();
                    }, 200);
                } catch (error) {
                    if (error) {
                        let focusComponentName = error[0]?.formattedKeyOrPath ?? '';

                        if (focusComponentName) {
                            form.focusOnComponent(focusComponentName);
                        }
                    } else {
                        alert('Something went wrong. Please refresh the page and try again.');
                    }
                }
            }
        });

        form.on('saveBeforeNextPage', (nextPage) => {
            // Capture the current page index
        });

        form.on('saveBeforePreviousPage', (previousPage) => {
            const currentPage = form.page;
            if (currentPage > 0) {
                lastVisitedPage = currentPage - 1;
                previousPageIndex = lastVisitedPage - 1;

                form.setPage(lastVisitedPage).then(() => {
                    currentPageNumber = lastVisitedPage;

                    setTimeout(() => {
                        applyPaginationStyling();
                    }, 200);

                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                });
            }
        });

        form.on('nextPage', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });

            $('.btn-wizard-nav-submit').length ? $('.btn-wizard-nav-submit').addClass('d-none') : null;

            // APPLY STYLING IMMEDIATELY
            setTimeout(() => {
                applyPaginationStyling();
            }, 200);
        });

        form.on('change', (event) => {
            try {
                if (event.changed && event.changed.component && event.changed.component.key === 'language') {
                    const selectedLang = event.data.language;
                    if (selectedLang) {
                        form.language = selectedLang;
                        form.redraw();
                    }
                }

                addMoveButtons();

                const changedComponent = event.changed && event.changed.component ? event.changed.component : null;
                const changedComponentInstance = event.changed && event.changed.instance ? event.changed.instance : null;
                const data = event.data ? event.data : null;
                const changedComponentKey = changedComponent && changedComponent.key ? changedComponent.key : '';
                let verifiedFieldValue = data[changedComponentKey + 'Verified'] ? data[changedComponentKey + 'Verified'] : '';
                let errorValidationCheck = true;

                let verifyLinkID = 'verify-email-id';

                if (changedComponentKey === 'alternateEmailId') {
                    verifyLinkID = 'verify-alternate-email-id';
                } else if (changedComponentKey === 'mobileNumber') {
                    verifyLinkID = 'verify-mobile-no';
                } else if (changedComponentKey === 'aadhaarNumber') {
                    verifyLinkID = 'validate-aadhaar';
                }

                if (changedComponent && (changedComponentKey === 'emailId' || changedComponentKey === 'mobileNumber' || changedComponentKey === 'aadhaarNumber')) {
                    //changedComponentKey === 'aadhaarNumber' || changedComponentKey === 'alternateEmailId' || 
                    // Check the same value entered in another field
                    errorValidationCheck = changedComponentInstance && changedComponentInstance.error && changedComponentInstance.error.message && changedComponentInstance.error.message != '' ? false : true;

                    // Unique value check with database
                    errorValidationCheck = changedComponentInstance && changedComponentInstance.error && changedComponentInstance.error.message && changedComponentInstance.error.message != '' ? false : true;
                    if (errorValidationCheck) {
                        let doYouWantUniqueCheck = formDefinition.doYouWantUniqueCheck ? formDefinition.doYouWantUniqueCheck : 'No';
                        let typeOfUniqueCheck = formDefinition.typeOfUniqueCheck ? formDefinition.typeOfUniqueCheck : '';

                        if (doYouWantUniqueCheck === 'Yes' && typeOfUniqueCheck === 'individual' && verifiedFieldValue !== 'Yes') {
                            customUniqueValidation(form, changedComponentKey).then(function (uniqueCheckResponse) {
                                if (uniqueCheckResponse === false) {
                                    $("#" + verifyLinkID).hasClass("disabled disabled-link") ? '' : $("#" + verifyLinkID).addClass("disabled disabled-link");
                                    const submitButton = form.getComponent('submit');
                                    if (submitButton) {
                                        submitButton.loading = false;
                                        submitButton.disabled = false;

                                        // Refresh the button's appearance to remove the loader
                                        submitButton.redraw();

                                        form.emit('submitError', "error");
                                        return false;
                                    }
                                }
                            });
                        }
                    }

                    // Field Verification Check, 
                    errorValidationCheck = changedComponentInstance && changedComponentInstance.error && changedComponentInstance.error.message && changedComponentInstance.error.message != '' ? false : true;
                    const newValue = data[changedComponentKey];
                    if (errorValidationCheck) {
                        if (verifiedFieldValue != 'Yes') {
                            $("#" + verifyLinkID).hasClass("disabled-link") ? $("#" + verifyLinkID).removeClass("disabled-link") : '';

                            // Check the verification during field value change
                            let component = form.getComponent(changedComponentKey);
                            if (form.submission && form.submission.data[component.key] != '') {
                                verificationErrorLabel = component.t('Please verify the {{ field }}', {
                                    field: component.errorLabel,
                                    data: component.data
                                });
                                component.setCustomValidity(verificationErrorLabel);
                                component.invalid = true;
                                // Focus on the input field with the dynamic name attribute
                                $('[name="data[' + component.key + ']"]').focus();
                            }
                        } else {
                            $("#" + verifyLinkID).hasClass("disabled-link") ? '' : $("#" + verifyLinkID).addClass("disabled-link");
                        }
                    } else {
                        $("#" + verifyLinkID).hasClass("disabled-link") ? '' : $("#" + verifyLinkID).addClass("disabled-link");
                    }
                }

                // You can add your custom logic here, such as updating other components or performing calculations.
            } catch (error) {
                console.error('An error occurred:', error);
            }
        });

        // Triggered when they click the submit button.
        form.on('submit', function (submission) {
            submission.form_master_id = formMasterId;
            let submitFlag = true;

            checkProfileVerifications(form).then(function (checkResponse) {
                if (checkResponse === false) {
                    let submitButton = form.getComponent('submit');
                    if (submitButton) {
                        submitButton.loading = false;
                        submitButton.disabled = false;

                        // Refresh the button's appearance to remove the loader
                        submitButton.redraw();

                        form.emit('submitError', "error");
                        return false;
                    }
                } else {
                    customUniqueValidation(form).then(function (submitResponse) {
                        if (submitFlag == false) {
                            form.emit('submitError', "error");
                            return false;
                        }
                        const dateComponentKeys = ['appliedDate', 'dateOfBirth', 'expectedDateOfCompletion', 'offerDate', 'issuedDate', 'validUpto', 'sslcStartDate', 'sslcEndDate', 'hscStartDate', 'hscEndDate', 'diplomaStartDate', 'diplomaEndDate', 'ugStartDate', 'ugEndDate', 'pgStartDate', 'pgEndDate', 'issueDate', 'expiryDate', 'durationFrom', 'durationTo', 'durationFromEmployment', 'durationToEmployment', "durationTo"]; // Array of component keys for date fields

                        dateComponentKeys.forEach((componentKey) => {
                            const component = form.getComponent(componentKey);
                            if (component && component.type === 'datetime') {
                                const dateValue = form.submission.data[component.key];
                                const convertedDate = moment(dateValue, 'YYYY-MM-DD').format('DD-MMM-YYYY');
                                form.submission.data[component.key] = convertedDate;
                            }
                        });

                        if (submitResponse === false) {
                            const submitButton = form.getComponent('submit');
                            if (submitButton) {
                                submitButton.loading = false;
                                submitButton.disabled = false;

                                // Refresh the button's appearance to remove the loader
                                submitButton.redraw();

                                form.emit('submitError', "error");
                                return false;
                            }
                        } else {
                            let formData = form.submission;
                            saveFormData(form);
                        }
                    });
                }
            });
        });

        // Mobile Number & Email Address OTP Verification
        var elementApiAttr = {
            'mobileNumber': 'mobile',
            'emailId': 'email',
            'alternateEmailId': 'email'
        };

        $(document).on('click', '#verify-mobile-no, #verify-email-id, #verify-alternate-email-id, #send-m-otp', async function (event) {
            event.preventDefault();
            var eve = this;
            var eveId = $(eve).attr('id');
            let actionName = '';
            let inputVal = '';
            let inputElement = '';
            if (eveId == 'send-m-otp') {
                inputElement = Object.keys(form.submission.data);
                inputElement = "mobileNumber";
                inputVal = form.submission.data.mobileNumber;
                let sendOTPButton = form.getComponent('sendOtpBtn');
                sendOTPButton.loading = true;
                sendOTPButton.disabled = true;
                // Refresh the button's appearance to remove the loader
                sendOTPButton.redraw();
            } else if (eveId == 'verify-mobile-no') {
                inputElement = Object.keys(form.submission.data);
                inputElement = "mobileNumber";
                inputVal = form.submission.data.mobileNumber;
            } else if (eveId == 'verify-alternate-email-id') {
                inputElement = Object.keys(form.submission.data);
                inputElement = "alternateEmailId";
                inputVal = form.submission.data.alternateEmailId;
            } else {
                inputElement = Object.keys(form.submission.data);
                inputElement = "emailId";
                inputVal = form.submission.data.emailId;
            }
            actionName = $(this).data('action') ? $(this).data('action') : '';


            if (inputElement != '' && inputVal != '') {
                let doYouWantUniqueCheck = formDefinition?.doYouWantUniqueCheck ?? 'No';
                let typeOfUniqueCheck = formDefinition?.typeOfUniqueCheck ?? '';

                let individualComponentDefinition = await findObjectByKeyValue(formDataDefinition, 'key', inputElement);
                let checkUnqiue = individualComponentDefinition?.unique ?? false;

                if (doYouWantUniqueCheck.toLowerCase() === 'Yes' && typeOfUniqueCheck === 'individual' && checkUnqiue) {
                    customUniqueValidation(form, inputElement).then(function (uniqueCheckResponse) {
                        if (uniqueCheckResponse === false) {
                            const submitButton = form.getComponent('submit');
                            if (submitButton) {
                                submitButton.loading = false;
                                submitButton.disabled = false;

                                // Refresh the button's appearance to remove the loader
                                submitButton.redraw();

                                form.emit('submitError', "error");
                                return false;
                            }
                        } else {
                            generateOtp(inputElement, inputVal, eve, actionName);
                        }
                    });
                } else {
                    generateOtp(inputElement, inputVal, eve, actionName);
                }
            }

        });

        $(document).on('click', '#validate-aadhaar', function (event) {
            event.preventDefault();

            let inputElement = "aadhaarNumber";
            let inputVal = form.submission.data.aadhaarNumber;

            validateAadhaar(inputElement, inputVal, this);
        });

        var inputValue;
        var token = '';

        function generateOtp(inputElement, inputVal, eve, actionName = '', checkUnqiue = false) {
            let inputKey = elementApiAttr[inputElement];
            let inputName = $(eve).attr('data-parentLabel') ? $(eve).attr('data-parentLabel') : $(eve).attr('data-parent');
            let inputId = $(eve).attr('id');
            let enableCaptcha = $(eve).attr('data-enableCaptcha') ?? 'no';
            let checkExists = $(eve).attr('data-checkExists') ?? 'no';
            let resendName = (inputKey == 'mobile') ? `<a href="#" id="${inputId}" class="float-right" style="font-size: 14px" data-action="re-generate"><u>Resend OTP</u></a>` : `<a href="#" id="${inputId}" class="float-right" style="font-size: 14px;" data-action="re-generate"><u>Resend Verification Code</u></a>`;
            let resendMsg = (inputKey == 'mobile') ? 'OTP resend successfully to your mobile number' : 'Verification code resend successfully to your ' + inputName;
            let confirmButtonText = $(eve).attr('data-confirmButtonText') ? $(eve).attr('data-confirmButtonText') : 'Verify';

            let data = {};
            inputValue = inputVal;
            data['jobNotificationId'] = formDefinition?.jobNotificationId ?? '';
            data['formMasterId'] = formMasterId ?? '';
            data['identifierType'] = inputKey ?? 'mobile';
            data['identifierFieldName'] = inputElement ?? '';
            data['identifierFieldLabel'] = inputName ?? '';
            data['identifier'] = inputVal;
            data['checkUnqiue'] = checkUnqiue;

            if (checkExists === 'yes') {
                checkUnqiue = data['checkUnqiue'] = true;
            }
            if (enableCaptcha === 'yes') {
                data['captchaInput'] = form?.submission?.data?.captchaInput ?? '';
            }

            if (inputKey == 'email')
                data['content'] = formDefinition.emailContentToBePublished;

            Swal.getValidationMessage() ? Swal.resetValidationMessage() : ''; // Reset the validation message
            $('#resend-success-alert').addClass('d-none'); // Reset the success alert

            $.ajax({
                url: "/generate-otp",
                method: "POST",
                data: data,
                success: function (response) {
                    if (response.success) {
                        token = response.token;
                        if (actionName != 're-generate') {
                            Swal.fire({
                                title: "",
                                html: '<h4>OTP Verification</h4>' +
                                    '<hr>' +
                                    `<div class="alert alert-default-success d-none" id="resend-success-alert">${resendMsg}</div>` +
                                    `<p>We have sent a verification code to the given ${inputName} <b>${inputVal}</b>. Please enter the code here to verify.</p>` +
                                    '<label for="verifyOTP" class="form-label mt-2">Verification Code</label>' +
                                    '<input type="text" class="form-control" name="verifyOTP" id="verifyOTPVal" placeholder="______" data-slots="_" data-accept="\w" maxlength="6">' +
                                    `${resendName}`,
                                showCloseButton: true,
                                allowOutsideClick: false,
                                showCancelButton: false,
                                allowEscapeKey: false,
                                showLoaderOnConfirm: true,
                                confirmButtonText: confirmButtonText,
                                preConfirm: () => {
                                    return new Promise(function (resolve, reject) {
                                        const otp = document.getElementById("verifyOTPVal").value;
                                        if (!otp) {
                                            Swal.showValidationMessage("Please enter your OTP!");
                                            reject();

                                            // Reset OTP input and enable verify button
                                            $('#verifyOTPVal').val('');
                                            $('.swal2-confirm').prop("disabled", false);
                                        } else if (!/^\d{6}$/.test(otp)) {
                                            Swal.showValidationMessage('Please enter a 6-digit numeric OTP');
                                            reject();

                                            // Reset OTP input and enable verify button
                                            $('#verifyOTPVal').val('');
                                            $('.swal2-confirm').prop("disabled", false);
                                        } else {
                                            let verifyInputElement = inputKey;
                                            let otp = document.getElementById('verifyOTPVal').value;

                                            let data = {};
                                            data['token'] = token;
                                            data['otp'] = otp;

                                            data['jobNotificationId'] = formDefinition?.jobNotificationId ?? '';
                                            data['formMasterId'] = formMasterId ?? '';
                                            data['identifierType'] = inputKey ?? 'mobile';
                                            data['identifierFieldName'] = inputElement ?? '';
                                            data['identifierFieldLabel'] = inputName ?? '';
                                            data['identifier'] = inputVal;
                                            data['checkUnqiue'] = checkUnqiue;

                                            $('#resend-success-alert').addClass('d-none'); // Reset the success alert

                                            // Perform the AJAX request
                                            $.ajax({
                                                url: "/validate-otp",
                                                method: "POST",
                                                data: data,
                                                success: function (response) {
                                                    let inputElementName = (verifyInputElement == 'mobile') ? `data[${inputElement}]` : `data[${inputElement}]`;
                                                    if (response.success === true) {
                                                        $('input[name="' + inputElementName + '"]').prop("disabled", true);
                                                        $('a#' + inputId).prop("disabled", true);

                                                        $(eve).text('Verified').addClass('disabled disabled-link').parent('span.input-group-text').addClass('bg-green');
                                                        form.submission.data[inputElement + 'Verified'] = 'Yes';

                                                        let componentDefinition = form.getComponent(inputElement);
                                                        componentDefinition.setCustomValidity('');
                                                        componentDefinition.invalid = false;

                                                        let message = 'Your OTP has been verified successfully';
                                                        let successRedirectURL = response?.redirectURL ?? '';

                                                        Swal.fire({
                                                            title: response.title ? response.title : 'Verified',
                                                            html: message,
                                                            icon: 'success',
                                                            showCancelButton: false,
                                                            confirmButtonText: 'OK',
                                                            allowOutsideClick: false,
                                                            allowEscapeKey: false
                                                        }).then((result) => {
                                                            // Reloading the captcha on verify otp
                                                            reloadCaptcha();
                                                            if (result.isConfirmed && (successRedirectURL != '')) {
                                                                window.location.href = successRedirectURL;
                                                            }
                                                        });
                                                        resolve();
                                                    } else {
                                                        // Reset OTP input and enable verify button
                                                        $('#verifyOTPVal').val('');
                                                        $('.swal2-confirm').prop("disabled", false);
                                                        $('a#' + inputId).removeClass('disabled disabled-link');
                                                        Swal.hideLoading();
                                                        Swal.enableButtons();
                                                        Swal.showValidationMessage(response.message);
                                                        reject();
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        } else {
                            if (actionName == 're-generate') {
                                $('div#resend-success-alert').removeClass('d-none');
                            }
                        }
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: response.message,
                            willClose: function () {
                                // Reset OTP input and enable verify button
                                $('#verifyOTPVal').val('');
                                $('.swal2-confirm').prop("disabled", false);
                                $('a#' + inputId).removeClass('disabled disabled-link');
                            }
                        });
                    }
                }
            });
        }

        function validateAadhaar(inputElement, inputVal, eve) {
            let inputId = $(eve).attr('id');
            let cleanAadhaar = (inputVal || '').replace(/\s+/g, '');

            if (!cleanAadhaar || !/^\d{12}$/.test(cleanAadhaar)) {
                Swal.fire('Error', 'Enter valid Aadhaar number', 'error');
                return;
            }

            // console.log(inputVal);
            // ✅ Basic validation
            // if (!inputVal || inputVal.length !== 12) {
            //     Swal.fire('Error', 'Enter valid Aadhaar number', 'error');
            //     return;
            // }

            // Disable link to prevent multiple clicks
            $('a#' + inputId).addClass('disabled');

            // 🔄 Loader
            Swal.fire({
                title: 'Validating Aadhaar...',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading()
            });

            $.ajax({
                url: "/validate-aadhaar",
                method: "POST",
                data: {
                    aadhaar: cleanAadhaar
                },

                success: function (response) {
                    Swal.close();
                    if (!response.success) {
                        $('a#' + inputId).removeClass('disabled');
                        Swal.fire('Error', response.message || 'Validation failed', 'error');
                        return;
                    }

                    const apiLastDigits = response.data.last_digits;
                    // ✅ Check if mobile linked
                    if (!response.data.is_mobile) {
                        $('a#' + inputId).removeClass('disabled');
                        Swal.fire({
                            icon: 'error',
                            title: 'Validation Failed',
                            text: 'No mobile number is linked with this Aadhaar'
                        });
                        return;
                    }

                    // 🔥 Ask last 3 digits of mobile
                    Swal.fire({
                        title: 'Aadhaar Validation',
                        html: `
                                    <p>Enter the <b>last 3 digits of the mobile number</b> linked with your Aadhaar</p>
                                    <input type="text" id="aadhaarLast3" class="form-control" maxlength="3" placeholder="XXX">
                                `,
                        confirmButtonText: 'Validate',
                        allowOutsideClick: false,
                        preConfirm: () => {
                            const val = document.getElementById('aadhaarLast3').value;

                            if (!val) {
                                Swal.showValidationMessage('Please enter last 3 digits');
                                return false;
                            }

                            if (!/^\d{3}$/.test(val)) {
                                Swal.showValidationMessage('Enter valid 3 digits');
                                return false;
                            }
                            return val;
                        }
                    }).then((result) => {

                        if (!result.isConfirmed) {
                            $('a#' + inputId).removeClass('disabled');
                            return;
                        }

                        const userInput = result.value.trim();
                        if (userInput === apiLastDigits) {
                            // ✅ SUCCESS UI
                            $('input[name="data[' + inputElement + ']"]').prop("disabled", true);

                            $('a#' + inputId)
                                .text('Validated')
                                .addClass('disabled disabled-link')
                                .parent('span.input-group-text')
                                .addClass('bg-green');

                            // ✅ Set verified flag
                            form.submission.data[inputElement + 'Verified'] = 'Yes';

                            let component = form.getComponent(inputElement);
                            component.setCustomValidity('');
                            component.invalid = false;

                            Swal.fire({
                                icon: 'success',
                                title: 'Validated',
                                text: 'Aadhaar Validated Successfully'
                            });

                        } else {

                            // ❌ FAILURE
                            form.submission.data[inputElement + 'Verified'] = 'No';

                            $('a#' + inputId)
                                .text('Validate Aadhaar')
                                .removeClass('disabled disabled-link')
                                .parent('span.input-group-text')
                                .removeClass('bg-green');

                            Swal.fire({
                                icon: 'error',
                                title: 'Mismatch',
                                text: 'Entered digits do not match Aadhaar registered mobile number'
                            });
                        }

                        form.emit('change');
                    });

                },

                error: function () {
                    Swal.close();
                    $('a#' + inputId).removeClass('disabled');

                    Swal.fire('Error', 'Server error while validating Aadhaar', 'error');
                }
            });
        }

    });
});

// Function to calculate the full age, including days, based on the birthdate
function calculateFullAge(birthdate, ageondate) {
    if (birthdate !== undefined && birthdate !== '' && birthdate !== null) {
        var birthdateObj = new Date(birthdate);
        var currentDate = new Date(ageondate);
        var years = currentDate.getFullYear() - birthdateObj.getFullYear();
        var months = currentDate.getMonth() - birthdateObj.getMonth();
        var days = currentDate.getDate() - birthdateObj.getDate();

        if (months < 0 || (months === 0 && days < 0)) {
            years--;
            months += 12;
        }

        if (days < 0) {
            var prevMonthLastDay = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0).getDate();
            days += prevMonthLastDay;
            months--;
        }
        return years + ' YEARS, ' + months + ' MONTHS, ' + days + ' DAYS';
    } else {
        return '';
    }
}

async function findObjectByKeyValue(array, key, value) {
    return array.find(obj => obj[key] === value);
}

async function customUniqueValidation(form, individualComponentKey = '') {
    let uniqueComponents = [];
    let componentKey = '';
    let componentDefinition = {};
    let doYouWantUniqueCheck = formDefinition.doYouWantUniqueCheck ? formDefinition.doYouWantUniqueCheck : 'No';
    let typeOfUniqueCheck = formDefinition.typeOfUniqueCheck ? formDefinition.typeOfUniqueCheck : '';
    if (doYouWantUniqueCheck === 'Yes') {
        let uniqueFormData = [];
        let uniqueComponentKeys = [];
        let uniqueErrorLabel = 'Combination of ';
        if (typeOfUniqueCheck === 'combination') {
            if (formDataDefinition instanceof Array) {
                for (var prop in formDataDefinition) {
                    if (formDataDefinition[prop] && formDataDefinition[prop].unique === true) {
                        componentKey = formDataDefinition[prop].key ? formDataDefinition[prop].key : '';
                        if (componentKey != '' && form.submission && form.submission.data[componentKey] && form.submission.data[componentKey].trim() != '') {
                            componentDefinition = form.getComponent(componentKey);
                            uniqueComponents.push(componentDefinition);
                        }
                    }
                }
            }

            if (uniqueComponents.length) {
                uniqueComponents.forEach((component) => {
                    if (form.submission && form.submission.data[component.key] != '') {
                        uniqueFormData.push({
                            key: component.key,
                            value: form.submission.data[component.key]
                        });
                        uniqueComponentKeys.push({
                            key: component.key,
                            label: component.label
                        });

                        if (uniqueComponents.length == 1) {
                            uniqueErrorLabel = component.t(component.errorMessage('unique'), {
                                field: component.errorLabel,
                                data: component.data
                            });
                        } else {
                            uniqueErrorLabel += component.label + ', ';
                        }
                    }
                });

                if (uniqueComponents.length > 1) {
                    uniqueErrorLabel = uniqueErrorLabel.trim(', ');

                    let lastComma = uniqueErrorLabel.lastIndexOf(',');
                    uniqueErrorLabel = uniqueErrorLabel.substring(0, lastComma);

                    lastComma = uniqueErrorLabel.lastIndexOf(',');
                    uniqueErrorLabel = uniqueErrorLabel.substring(0, lastComma) + ' and' + uniqueErrorLabel.substring(lastComma + 1);

                    uniqueErrorLabel = uniqueErrorLabel + ' are already exists.';
                }
            }
        } else if (typeOfUniqueCheck === 'individual' && individualComponentKey != '') {
            let individualComponent = form.getComponent(individualComponentKey);
            uniqueComponents.push(individualComponent);

            if (individualComponent && form.submission && form.submission.data[individualComponent.key] != '') {
                uniqueFormData.push({
                    key: individualComponent.key,
                    value: form.submission.data[individualComponent.key]
                });
                uniqueComponentKeys.push({
                    key: individualComponent.key,
                    label: individualComponent.label
                });

                if (uniqueComponents.length == 1) {
                    uniqueErrorLabel = individualComponent.t(individualComponent.errorMessage('unique'), {
                        field: individualComponent.errorLabel,
                        data: individualComponent.data
                    });
                }
            }
        }

        if (uniqueFormData.length) {
            return new Promise(function (resolve, reject) {
                return fetch('/job-notification/check-unique-data', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': csrfToken
                    },
                    body: JSON.stringify({
                        uniqueFormData: uniqueFormData,
                        form_master_id: formMasterId
                    })
                }).then(response => {
                    return response.json();
                }).then(data => {
                    if (data.success) {
                        return resolve(true);
                    } else {
                        return resolve(false);
                    }
                });
            }).then(res => {
                if (!res) {
                    let message = uniqueErrorLabel;
                    if (uniqueComponentKeys.length) {
                        uniqueComponents.forEach((component) => {
                            component.setCustomValidity(message);
                            component.invalid = true;
                            if (typeOfUniqueCheck === 'combination') {
                                let eve = '';
                                if (component.key === 'emailId') {
                                    eve = 'a#verify-email-id';
                                } else if (component.key === 'alternateEmailId') {
                                    eve = 'a#verify-alternate-email-id';
                                } else {
                                    eve = 'a#verify-mobile-no';
                                }

                                $('input[name="' + component.key + '"]').removeAttr("disabled");
                                $(eve).html('<u>Verify</u>').addClass('disabled disabled-link').parent('span.input-group-text').removeClass('bg-green');
                                form.submission.data[component.key + 'Verified'] = 'No';
                            }
                        });
                    }
                }
                return res;
            }).catch(error => {
                return false;
            });
        } else {
            return true;
        }
    } else {
        return true;
    }
}

async function checkProfileVerifications(form) {
    let verifyComponents = [];
    let componentKey = '';
    let componentDefinition = {};
    if (formDataDefinition instanceof Array) {
        for (var prop in formDataDefinition) {
            if (formDataDefinition[prop] && formDataDefinition[prop].fieldVerifyFlag && formDataDefinition[prop].fieldVerifyFlag === 'Yes') {
                let verifyFieldName = formDataDefinition[prop].verifyFieldName ? formDataDefinition[prop].verifyFieldName : '';
                let fieldValue = form.submission.data[verifyFieldName];
                if (verifyFieldName != '' && fieldValue != '') {
                    componentKey = formDataDefinition[prop].key ? formDataDefinition[prop].key : '';
                    let fieldVerifyStatus = form.submission.data[componentKey];
                    if (fieldVerifyStatus != 'Yes') {
                        componentDefinition = form.getComponent(verifyFieldName);
                        verifyComponents.push(componentDefinition);
                    }
                }
            }
        }
    }
    if (verifyComponents.length) {
        let verificationErrorLabel = '';
        verifyComponents.forEach((component) => {
            if (form.submission && form.submission.data[component.key] != '') {
                verificationErrorLabel = component.t('Please verify the {{ field }}', {
                    field: component.errorLabel,
                    data: component.data
                });
                component.setCustomValidity(verificationErrorLabel);
                component.invalid = true;
                // Focus on the input field with the dynamic name attribute
                $('[name="data[' + component.key + ']"]').focus();
            }
        });
    } else {
        return true;
    }
    return false;
}

// Function to save the form data
function saveFormData(form, actionName = '', currentPageIndex = 0) {
    // Replace this with your own implementation to save the form data
    // For example, you can make an API request to save the data
    // axios.post('your-save-endpoint', formData);
    return Formio.fetch(formSubmissionUrl, {
            body: JSON.stringify(form.submission),
            headers: {
                'content-type': 'application/json',
                'X-CSRF-TOKEN': csrfToken,
                'page-Number': currentPageIndex ? currentPageIndex : 0
            },
            method: 'POST',
            mode: 'cors',
        })
        .then(function (response) {
            response.json().then(function (result) {
                // console.log('Form submission result:', result);
                // console.log('Response status:', response.status);
                let successMsg = result.message ? result.message : "You will be redirected to another page.";
                let redirectUrl = result.redirectURL ? result.redirectURL : '';

                if (actionName == '') {
                    // console.log('Action name is empty, proceeding with submission result handling.');
                    if (response.status == 200) {
                        if (result.success) {
                            Swal.fire({
                                title: result.title ? result.title : 'Redirect',
                                html: successMsg,
                                icon: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    form.emit('submitDone', '');
                                    if (redirectUrl != '') {
                                        window.location.href = redirectUrl;
                                    }
                                }
                            });
                        } else {
                            Swal.fire({
                                icon: 'error',
                                title: result.title ? result.title : 'Oops...',
                                text: result.message,
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((result) => {
                                form.emit('submitError', '');

                                // Error occurred during submission
                                const submitButton = form.getComponent('submit');
                                if (submitButton) {
                                    submitButton.loading = false;
                                    submitButton.disabled = false;
                                    // Refresh the button's appearance to remove the loader
                                    submitButton.redraw();
                                }

                                // Reload the page
                                if (result.isConfirmed) {
                                    if (redirectUrl != '') {
                                        window.location.href = redirectUrl;
                                    } else {
                                        // Reload the page
                                        // location.reload(); // or window.location.reload();
                                    }
                                }
                            });
                        }
                    } else {
                        // console.log('Response status:', response.status);
                        Swal.fire({
                            icon: 'error',
                            title: result.title ? result.title : 'Error',
                            text: result.message,
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((result) => {
                            form.emit('submitError', '');

                            // Error occurred during submission
                            const submitButton = form.getComponent('data[nextToPrevious]');
                            if (submitButton) {
                                submitButton.loading = false;
                                submitButton.disabled = false;
                                // Refresh the button's appearance to remove the loader
                                submitButton.redraw();
                            }

                            // Reload the page
                            if (result.isConfirmed) {
                                if (redirectUrl != '') {
                                    window.location.href = redirectUrl;
                                } else {
                                    // Reload the page
                                    // location.reload(); // or window.location.reload();
                                }
                            }
                        });
                    }
                } else {
                    // console.log(`Action name is not empty, handling accordingly: ${actionName}`);
                    if (response.status > 200) {
                        Swal.fire({
                            icon: 'error',
                            title: result.title ? result.title : 'Oops...',
                            text: result.message,
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((result) => {
                            form.emit('submitError', '');

                            // Error occurred during submission
                            const submitButton = form.getComponent('data[nextToPrevious]');
                            if (submitButton) {
                                submitButton.loading = false;
                                submitButton.disabled = false;
                                // Refresh the button's appearance to remove the loader
                                submitButton.redraw();
                            }

                            // Reload the page
                            if (result.isConfirmed) {
                                if (redirectUrl != '') {
                                    window.location.href = redirectUrl;
                                } else {
                                    // Reload the page
                                    location.reload(); // or window.location.reload();
                                }
                            }
                        });
                    }
                }
            });
        });
}

$(function () {
    // To block the browser's copy and paste feature
    var formContainer = document.getElementById('formio');
    formContainer.addEventListener('copy', function (e) {
        e.preventDefault();
    });

    formContainer.addEventListener('paste', function (e) {
        e.preventDefault();
    });

    window.addEventListener('beforeunload', function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Scroll to the top smoothly
        });
    });

    // To block the browser's back button and prevent users from navigating backward
    // window.history.pushState(null, '', window.location.href);
    // window.onpopstate = function () {
    //     location.reload();
    //     // window.history.go(1);
    // };
    window.history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function () {
        window.history.pushState(null, null, document.URL);
    });

    // To block the browser's forward button and prevent users from navigating forward
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('beforeunload', function () {
        window.history.forward(1);
    });

    // Reload CAPTCHA on button click
    $(document).on('click', '#reload-captcha', function (event) {
        // console.log('reloadCaptcha clicked event');
        event.preventDefault();
        reloadCaptcha();
    });

})

// Function to reload CAPTCHA
function reloadCaptcha() {
    // console.log('reloading Captcha');
    const captchaImage = document.getElementById('captcha-image');
    captchaImage.src = '/captcha/flat?' + Math.random(); // Random query to force reload
}

// Initial call to apply the styling after DOM is fully loaded
$(document).ready(function () {
    setTimeout(function () {
        applyPaginationStyling();
    }, 300);
});

// Function to apply the class to buttons with the specific logic
function applyPaginationStyling() {
    let lastVisitedPage = parseInt(formData?.profileCompletedPage ?? 0);
    let activePage = parseInt(currentPageNumber ?? 0);
    let maxPageCount = Math.max(lastVisitedPage, activePage);

    // Remove old styles
    $('.pagination li.page-item button.page-link').removeClass('bg-success');

    $('.pagination li.page-item').each(function (index) {
        const pageItem = $(this);
        const pageLinkButton = pageItem.find('button.page-link');

        // Skip active page
        if (pageItem.hasClass('active')) {
            return;
        }

        // Apply success style to completed pages
        if (index < maxPageCount) {
            pageLinkButton.addClass('bg-success');
        }
    });
}

function isMobileDevice() {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}

function isMobileView() {
    return window.innerWidth < 768;
}

function showMobileWarning() {
    // console.log('Mobile device detected, showing warning...');
    if (mobileAlertVisible) return; // Prevent re-showing if already active

    mobileAlertVisible = true;

    Swal.fire({
        icon: 'warning',
        title: 'Desktop Access Recommended',
        text: 'This form is best accessed and submitted using a desktop or laptop browser. Mobile devices are not supported for this process. Thank you for your understanding.',
        confirmButtonText: 'OK',
        allowEscapeKey: false,
        allowOutsideClick: false,
        showCloseButton: false,
        showConfirmButton: false,
        willClose: () => {
            mobileAlertVisible = false; // Reset flag when alert closes
        },
        customClass: {
            popup: 'mobile-warning-popup',
            title: 'mobile-warning-title',
            htmlContainer: 'mobile-warning-text'
        }
    });

    const formContainer = document.getElementById('formio');
    if (formContainer) formContainer.style.display = 'none';
}

function disableMobileWarning() {
    if (mobileAlertVisible) {
        Swal.close(); // Dismiss alert
        mobileAlertVisible = false;
    }

    const formContainer = document.getElementById('formio');
    if (formContainer) formContainer.style.display = 'block';
}

function handleResize() {
    // console.log('Checking if the view is mobile...');
    // Check if the window width is less than 768px
    // console.log('Current window width:', window.innerWidth);

    if (isMobileView()) { //isMobileDevice() ||
        showMobileWarning();
    } else {
        disableMobileWarning();
    }
}